import CommunityMeta from './CommunityMeta'

export default CommunityMeta
// eslint-disable-next-line import/export
export * from './CommunityMeta'
